import { db } from "@/firebase"

const dealership_token_ref = db.collection("dealership_token")

const updateCaptcha = async (captcha) => {
    try {
        await dealership_token_ref.doc("XIvpadkwGmqNuJJSGIYQ").update({ captcha, created_at: new Date() });
        return true;
    } catch (error) {
        throw new Error("updateCaptcha Fail!" + error)
    }
}

export default {
    updateCaptcha,
};